<div class="horizontalMenuBar flex-container" style="z-index:9999;">
    <!-- <div><h3 style="font-size: 16px;margin:0px;"><b>Forms Portal</b></h3></div> -->
    <a routerLink="/"><img src="/assets/images/SantosWeb.png" id="Santos Logo"
        style="display: inline-flex;justify-content: center;vertical-align: middle;height: 20px !important;margin: 10px !important;" /></a>
    <div class="toptext2">{{[(title.mainTitle)]}}<span class="toptext3">{{[(title.subTitle)]}}</span></div>
    <!-- <div style="width:20px;"></div> -->
    <div>
        <a routerLink="/" *ngIf="hideHomeIcon" style="padding: 4px 8px;">
            <span class="k-icon k-home k-icon-big"></span>
        </a>
        <kendo-dropdownbutton style="background-color: black;" look="flat" [data]="userData" class="k-user-dropdown">
            <span class="k-icon k-user k-icon-big"></span>
            <ng-template kendoDropDownButtonItemTemplate let-dataItem>
                <span class="k-dropdown-button-item">{{ dataItem.actionName }}</span>
            </ng-template>
        </kendo-dropdownbutton>
        <a target="_blank" href="assets/data/DashboardHelp.pdf" style="padding: 4px 8px;">
            <span class="k-icon k-gear k-icon-big"></span>
        </a>
        <a [routerLink]="routerEditLink" *ngIf="showEditIcon" style="padding: 4px 8px;">
            <span class="k-icon k-i-gear k-icon-big" style="color: white;"></span>
        </a>
    </div>
</div>

<!-- <div class="form">
  <div class="topbar">
    <div class="toptext">{{[(title)]}}</div>
  </div>
  <a routerLink="/">
    <img src="/assets/images/SantosWeb.png" style="position:absolute; left:1px; top:1px;" />
  </a>
  <div pull-right class="toptext2" style="position:absolute; right:10px; top:10px; font-size:small">
		Hi {{userMessage}} [v1.02]
  </div>
</div> -->
<div class="example-wrapper">
    <!-- <kendo-dialog title="Information" *ngIf="dialogOpenedUser" (close)="dialogUser('close')" [minWidth]="250" > -->
    <kendo-dialog title="Information" *ngIf="dialogOpenedUser" (close)="dialogUser('close')" [minWidth]="300">
        <fieldset>
            <div class="row">
                <div class="col-sm-6">
                    <label class="k-form-field">
                        <b>Unique ID:</b>
                    </label>
                </div>
                <div class="col-sm-6">
                    <label class="k-form-field">
                        {{globals.user.username}}
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <label class="k-form-field">
                        <b>Name:</b>
                    </label>
                </div>
                <div class="col-sm-6">
                    <label class="k-form-field">
                        {{globals.user.name}}
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <label class="k-form-field">
                        <b>Version:</b>
                    </label>
                </div>
                <div class="col-sm-6">
                    <label class="k-form-field">
                        {{appName}} {{globals.appVersion}}
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <label class="k-form-field">
                        <b>Device:</b>
                    </label>
                </div>
                <div class="col-sm-6">
                    <label class="k-form-field">
                        {{globals.device}}
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <label class="k-form-field">
                        <b>Saved to home screen:</b>
                    </label>
                </div>
                <div class="col-sm-6">
                    <label class="k-form-field">
                        <p *ngIf="globals.isInstalled">Yes</p>
                        <p *ngIf="!globals.isInstalled">No</p>
                    </label>
                </div>
            </div>
        </fieldset>

        <!-- <br><br><button kendoButton (click)="checkIfInstalled()"            primary="false">Check If Installed</button> -->

        <kendo-dialog-actions>
            <button kendoButton (click)="dialogUser('close')" primary="true">OK</button>
        </kendo-dialog-actions>
    </kendo-dialog>
</div>